// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2610":"bfc3b156","6178":"bfc3b156"}[chunkId] + ".chunk.css";
};